// (c) chaehongee. Confidential and proprietary.

import { createClient, SupabaseClient } from '@supabase/supabase-js'
import { getEnv } from './env'

let supabaseClient: SupabaseClient | null = null

export function getSupabaseClient(): SupabaseClient {
    if (!supabaseClient) {
        const { supabaseUrl, supabaseAnonKey } = getEnv()
        supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
            auth: {
                autoRefreshToken: true,
                persistSession: true,
                detectSessionInUrl: true,
            },
        })
    }
    return supabaseClient
}

